import DataCaptureForm from './DataCaptureForm';

import {selectElementText} from '../utilities/utilities';

/**
 * Consult README.md for compilation/transpilation instructions.
 * Contains JS functionality for thanks page which appears at
 * the end of the res sign up journey (plus.net/signup/thanks/)
 */
export default class Thanks {
    /**
     * @return {void}
     */
    constructor () {
        this.shareURLElement = document.querySelector('.js-share-url');
        this.shareURLButton = document.querySelector('.js-share-button');
        this.shareFeedbackElement = document.querySelector('.js-share-feedback');
        this.dataCaptureForm = new DataCaptureForm();
    }

    /**
     * @return {void}
     */
    init () {
        if (this.isOnThanksPage()) {
            this.dataCaptureForm.init();
            this.setupEvents();
            window.dataCaptureForm = this.dataCaptureForm;
        }
    }

    /**
     * @return {void}
     */
    setupEvents () {
        this.shareURLElement.addEventListener('click', () => {
            this.highlightReferralLink();
        });

        this.shareURLButton.addEventListener('click', () => {
            this.copyReferralLink();
        });
    }

    /**
     * @return {boolean}
     */
    isOnThanksPage () {
        return document.location.pathname.includes('signup/thanks');
    }

    /**
     * Selects the referral link text
     * @return {void}
     */
    highlightReferralLink () {
        selectElementText(this.shareURLElement);
    }

    /**
     * Selects and copies referral link to clipboard.
     * @return {void}
     */
    copyReferralLink () {
        this.highlightReferralLink();

        document.execCommand('copy');

        this.shareFeedbackElement.classList.add('is_active');

        setTimeout(() => {
            this.shareFeedbackElement.classList.remove('is_active');
        }, 5000);
    }
}
